import { memo, useMemo, useState } from 'react';
import { Backdrop, Fade, makeStyles, Modal } from '@material-ui/core';
import tw from 'twin.macro';
import InfoIcon from '@material-ui/icons/Info';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useAnalytics } from 'use-analytics';
import withSpinner from '../../../HOCs/withSpinner';
import { SearchStatus } from '../../../constants';
import { changeTrip } from '../../../store/slices/trip';

const useStyles = makeStyles(() => ({
  modal: tw`flex items-start justify-center p-20 overflow-auto`,
  paper: tw`p-8 bg-white flex flex-col justify-around items-center w-auto`,
  root: tw`h-16 w-16 fill-current text-blue-600 mb-5`,
}));

const DeleteConfirmationModal = ({ tripId }) => {
  const classes = useStyles();
  const router = useRouter();
  const dispatch = useDispatch();
  const { track } = useAnalytics();

  const { deleteTripStatus: deleteTripStatuses, deleteTripError } = useSelector(
    (store) => store.trip,
  );
  const deleteTripStatus = deleteTripStatuses[tripId];
  const { test } = router.query;
  const [doShowSpinner, setDoShowSpinner] = useState(false);
  const isConfirmationPage = router.pathname.indexOf('confirmation') > -1;
  const { isViewingBrochure } = useSelector((state) => state.brochure);
  const { isViewingCompare } = useSelector((state) => state.compare);

  const displayName = useMemo(() => {
    if (isViewingCompare) return 'compare';
    if (isConfirmationPage) return 'trip quote';
    if (isViewingBrochure) return 'brochure';
    return '';
  }, [isConfirmationPage, isViewingBrochure, isViewingCompare]);

  const handleGoBackToHomePage = () => {
    setDoShowSpinner(true);
    track('DeleteConfirmationModal.handleGoBackToHomePage', { page: displayName });
    router.push(`/${test === 'true' ? '?test=true' : ''}`);
  };

  const closeModal = () => {
    dispatch(changeTrip({ field: 'deleteTripError', value: undefined }));
    dispatch(
      changeTrip({
        field: 'deleteTripStatus',
        value: {
          ...deleteTripStatuses,
          [tripId]: SearchStatus.INITIAL,
        },
      }),
    );
  };

  const renderComponent = () => (
    <Modal
      className={classes.modal}
      open={deleteTripStatus}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={deleteTripStatus}>
        <div className={classes.paper}>
          <InfoIcon className={classes.root} />
          <h2 className="font-bold sm:text-sm xl:text-lg mb-2 text-center max-w-72">
            {deleteTripStatus === SearchStatus.DONE &&
              !deleteTripError &&
              `The ${displayName} has been deleted.`}
            {deleteTripStatus === SearchStatus.DONE && deleteTripError && (
              <div>
                Could not delete {displayName}
                <br />
                <br />
                {deleteTripError}
              </div>
            )}
          </h2>
          {deleteTripStatus ? <div className="border w-full border-b-1 my-5" /> : null}

          {deleteTripStatus === SearchStatus.DONE && deleteTripError && (
            <button onClick={closeModal} type="button" className="text-theme">
              Close
            </button>
          )}

          {deleteTripStatus !== SearchStatus.SEARCHING &&
            !deleteTripError &&
            withSpinner(
              () => (
                <button onClick={handleGoBackToHomePage} type="button" className="text-theme">
                  {deleteTripStatus && 'Go back to the Home Page.'}
                </button>
              ),
              doShowSpinner,
            )}
        </div>
      </Fade>
    </Modal>
  );

  return deleteTripStatus ? renderComponent() : '';
};
export default memo(DeleteConfirmationModal);
